export default __webpack_public_path__ + "static/new-window-before-07bb3c63e9e32c34e3be024e5af11775e665a20f0ffd3cf83d0b2c044bfa4e41.png";